import * as React from 'react';
import { Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { newMobileClientCheck, setQuoteType } from '../../../actions/salesActions';
import { DASHBOARD, PERSONAL_INFO, PORTABLE_POSSESSIONS } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import './PortablePossessions.css';
import { showOopsPortablePossessions } from '../../../actions/modalActions';
import { PRODUCT_PORTABLE_POSSESSIONS } from '../../../constants/constants';
import { logEvent } from '../../../firebase/firebase';

class GetPortablePossessionsInsurance extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loggedIn: this.props.auth.uid ? true : false
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleShowComingSoon = this.handleShowComingSoon.bind(this);
    }

    componentWillMount() {
        logEvent('SSP_get_portable_landed', 'user_landed_on_get_portable');
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async handleShowComingSoon() {
        this.props.dispatchShowOopsPortablePossessionError();
    }

   async handleRedirect() {
       logEvent('SSP_get_portable_add_to_quote', 'user_cliked_get_a_quote_portable');
       var nextPage = PERSONAL_INFO;
        if (this.props.profile.policyId !== "") {
            nextPage = PORTABLE_POSSESSIONS;
            await this.props.dispatchSetQuoteType();
            await this.props.dispatchCreditHistoryCheck();
        }
        this.props.redirectTo(nextPage);
    }

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        return (
            <div id="GetPortable" >
                <div className={this.state.loggedIn ? "container-fluid new-page-margins" : "logged-out"}>
                    <div className="new-breadcrumbwrapper breadcrumb-wrapper-claims-actual">
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Get portable possessions insurance" />
                    </div>
                    <div className="row new-page-main-row justify-content-center">
                        <Card id="GetPortalPossessionsInsuranceBanner" className="col content-box-padding-20px-with-box-shadow">
                            <div className="row noma possesions-parent-row">
                                <div className="nopa mobile-mb-30px image-holder">
                                    <img src="./Images/PortablePossessions/portable-possessions.svg" alt="" title="" className="portal-image-width" />
                                </div>
                                <div className="col nopa ml-42px mobile-ml-0px border-right portable-header">
                                    <h2 className="mb-1px mobile-mb-20px mr-20px mobile-mr-0px font-size-39px mobile-font-size-35px">Portable possessions <br className="mobile-br " /> insurance</h2>
                                    <p className="font-size-16px font-weight-normal mb-0px mr-20px mobile-mr-0px">Wherever you are, we’re there too</p>
                                </div>
                                <div className="nopa mobile-mt-30px get-portable-quote">
                                    <button className="btn btn-solid-green" onClick={this.handleRedirect}>Get a quote</button>
                                </div>
                            </div>
                        </Card>
                        <div className="col-12 nopa mb-15px">
                            <Card className="content-box-padding-20px-with-box-shadow">
                                <div>
                                    <h5 className="possession-header">In a nutshell</h5>
                                    <p className="font-size-12px font-weight-normal">This cover will repair or replace possessions, like clothing and cameras, tablets and travel luggage, and rings and sparkly things, if they're stolen or damaged while they're anywhere other than in your home. If your valuables are out on the town with you, or with someone who lives with you, and something bad happens to them. Don't worry! If you have insurance for your personal portable possessions with the king, you're covered, wherever you are in the world.</p>
                                </div>
                            </Card>
                        </div>
                        <Card className="content-box-padding-20px-with-box-shadow">
                            <div className="mb-30px ml-93px mr-93px mobile-mb-20px mobile-ml-0px mobile-mr-0px">
                                <div className="possession-header text-lg-center text-left">Specified vs. unspecified portable possessions</div>
                                <div className="ssp-portable-possessions-p-holder">
                                    <div className="font-size-12px font-weight-normal mb-0px">
                                        We know it's not polite to scratch around in other people's handbags, so we won't ask you to list everything that you carry around in yours. We'll cover these unspecified everyday items up to an amount that you choose.<br /><br />
                                        But, we do need you to specify some of your actual handbags, and a few other special portable possessions, such as:
                                    </div>
                                </div>
                            </div>
                            <div className="row noma">
                                <div className="col-12 col-lg-5 nopa">
                                    <div className="row noma">
                                        <div className="possession-image-holder">
                                            <img alt="" title="" src="./Images/PortablePossessions/icon-personal-insurance-handbags.svg" />
                                        </div>
                                        <div className="col nopa portable-description-parent">
                                            <p className="line-height-normal mb-6px"><b>Handbags</b></p>
                                            <p className="font-size-12px font-weight-normal mb-0px portable-description">Some handbags are even more valuable than the sum of all their contents! Whether it’s your Hermès lust-have or the hold-all you took on honeymoon, we’ll cover them all.</p>
                                        </div>
                                    </div>
                                    <hr className="portable-possessions-hr" />
                                </div>
                                <div className="portal-possession-gutter col-lg-1 nopa mobile-ml-0px"></div>
                                <div className="col-12 col-lg-5 nopa">
                                    <div className="row noma">
                                        <div className="possession-image-holder">
                                            <img alt="" title="" src="./Images/PortablePossessions/icon-personal-insurance-laptop.svg" />
                                        </div>
                                        <div className="col nopa portable-description-parent">
                                            <p className="line-height-normal mb-6px"><b>Laptop and tablets</b></p>
                                            <p className="font-size-12px font-weight-normal mb-0px portable-description">This includes notebooks, tablets and iPads, and portable microcomputers and hand-held pocket PCs… And your software.</p>
                                        </div>
                                    </div>
                                    <hr className="portable-possessions-hr" />
                                </div>
                            </div>
                            <div className="row noma">
                                <div className="col-12 col-lg-5 nopa">
                                    <div className="row noma">
                                        <div className="possession-image-holder">
                                            <img alt="" title="" src="./Images/PortablePossessions/icon-personal-insurance-jewellery.svg" />
                                        </div>
                                        <div className="col nopa portable-description-parent">
                                            <p className="line-height-normal mb-6px"><b>Jewellery</b></p>
                                            <p className="font-size-12px font-weight-normal mb-0px portable-description">Your bracelets and brooches, rings and earrings, cufflinks and other things with karats… In fact, all your expensive jewels and watches… We’ll cover them when you’re wearing them.</p>
                                        </div>
                                    </div>
                                    <hr className="portable-possessions-hr" />
                                </div>
                                <div className="portal-possession-gutter col-lg-1 nopa mobile-ml-0px"></div>
                                <div className="col-12 col-lg-5 nopa">
                                    <div className="row noma">
                                        <div className="possession-image-holder">
                                            <img alt="" title="" src="./Images/PortablePossessions/icon-personal-insurance-cellphone.svg" />
                                        </div>
                                        <div className="col nopa portable-description-parent">
                                            <p className="line-height-normal mb-6px"><b>Cellphone</b></p>
                                            <p className="font-size-12px font-weight-normal mb-0px portable-description">The 1 thing you never leave home without is your phone, so if it doesn’t come safely back home with you, we’ll replace it… Just as long as you’ve specified it as a portable possession.</p>
                                        </div>
                                    </div>
                                    <hr className="portable-possessions-hr" />
                                </div>
                            </div>
                            <div className="row noma">
                                <div className="col-12 col-lg-5 nopa">
                                    <div className="row noma">
                                        <div className="possession-image-holder">
                                            <img alt="" title="" src="./Images/PortablePossessions/icon-personal-insurance-camera-equipment.svg" />
                                        </div>
                                        <div className="col nopa portable-description-parent">
                                            <p className="line-height-normal mb-6px"><b>Cameras</b></p>
                                            <p className="font-size-12px font-weight-normal mb-0px portable-description">We’ll cover your camera and video equipment at an affordable premium, just as soon as you specify them.</p>
                                        </div>
                                    </div>
                                    <hr className="portable-possessions-hr camera-hr" />
                                </div>
                                <div className="portal-possession-gutter col-lg-1 nopa mobile-ml-0px"></div>
                                <div className="col-12 col-lg-5 nopa">
                                    <div className="row noma">
                                        <div className="possession-image-holder">
                                            <img alt="" title="" src="./Images/PortablePossessions/icon-personal-insurance-glasses.svg" />
                                        </div>
                                        <div className="col nopa portable-description-parent">
                                            <p className="line-height-normal mb-6px"><b>Glasses</b></p>
                                            <p className="font-size-12px font-weight-normal mb-0px portable-description">We just can’t see you leaving home without your specs and sunnies… So, we’ll cover them in case of theft or damage while you’re out and about.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchCreditHistoryCheck: () => dispatch(newMobileClientCheck("", true, null)),
        dispatchShowOopsPortablePossessionError: () => dispatch(showOopsPortablePossessions()),
        dispatchSetQuoteType: () => dispatch(setQuoteType(PRODUCT_PORTABLE_POSSESSIONS)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetPortablePossessionsInsurance);